import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "popper.js";
import "./assets/app.scss";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import "vue-loading-overlay/dist/vue-loading.css";
// import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
import DisablePasteMixin from './disablePasteMixin';

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.mixin(DisablePasteMixin);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
